<div class="catalog-card">
    <div class="catalog-card-header">
        <div class="catalog-card-title" nz-tooltip [nzTooltipTitle]="data['name']">{{data['name']}}</div>
        <div class="catalog-card-subtitle">
            GTIN: {{product_identifier}} | {{'meli.wizard.catalogCode'|translateTA}}: {{data['id']}}
        </div>
    </div>

    <div class="product-item-content">
        <div class="product-item-image">
            <carousel [arrowsOutside]="true" [arrowsTheme]="'dark'" [arrows]="true" [dots]="true" cellsToShow="3" cellWidth="120" cellHeight="120" height="120" width="360">
                <div class="carousel-cell" *ngFor="let image of data['pictures']">
                    <img [src]="image.url" [alt]="data['name']">
                </div>
            </carousel>
        </div>
        <div class="product-item-detail">
            <div class="product-item-detail-container">
                <div *ngFor="let item of data['attributes']; let i=index" [ngClass]="i<attribIndex ? 'product-item':'none'">
                    <div *ngIf="i<attribIndex" class="attrib-data">
                        <div class="label" nz-tooltip [nzTooltipTitle]="item['name']">{{item['name']}}</div>
                        <div class="value" nz-tooltip [nzTooltipTitle]="item['value_name']">{{item['value_name']}}</div>
                    </div>
                </div>
            </div>
            <button nz-button nzType="link" nzSize="small" *ngIf="attribIndex==1" (click)="attribIndex=999">{{'meli.wizard.showMore'|translateTA}}</button>
            <button nz-button nzType="link" nzSize="small" *ngIf="attribIndex!=1" (click)="attribIndex=1">{{'meli.wizard.showLess'|translateTA}}</button>
        </div>
    </div>

    <div class="card-action">
        <button nz-button nzType="primary" (click)="select(data)">{{'meli.wizard.choose'|translateTA}}</button>
        <button nz-button (click)="getBuyBox(data)">Buy-Box</button>
    </div>
</div>
